import { render, staticRenderFns } from "./DashboardCartes.vue?vue&type=template&id=0cc3efb0&scoped=true"
import script from "./DashboardCartes.vue?vue&type=script&lang=js"
export * from "./DashboardCartes.vue?vue&type=script&lang=js"
import style0 from "./DashboardCartes.vue?vue&type=style&index=0&id=0cc3efb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc3efb0",
  null
  
)

export default component.exports